import { render, staticRenderFns } from "./ResultFormBillBy.vue?vue&type=template&id=11c24a54&scoped=true&"
import script from "./ResultFormBillBy.vue?vue&type=script&lang=js&"
export * from "./ResultFormBillBy.vue?vue&type=script&lang=js&"
import style0 from "./ResultFormBillBy.vue?vue&type=style&index=0&id=11c24a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c24a54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11c24a54')) {
      api.createRecord('11c24a54', component.options)
    } else {
      api.reload('11c24a54', component.options)
    }
    module.hot.accept("./ResultFormBillBy.vue?vue&type=template&id=11c24a54&scoped=true&", function () {
      api.rerender('11c24a54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/components/ResultFormBillBy.vue"
export default component.exports